<script setup lang="ts">
import { ref, watch } from 'vue'
import type { Scenario } from '@/stores/type/scenario.type'

const props = defineProps({
  item: {
    type: Object as PropType<Scenario>,
    required: true
  },
  isOpen: {
    type: Boolean,
    required: true
  },
  helpText: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update', 'close'])

const isDialogOpen = ref(false)
const simulationName = ref('')

watch(
  () => props.item,
  (newItem) => {
    simulationName.value = newItem.name
  },
  { immediate: true, deep: true }
)

watch(
  () => props.isOpen,
  (newVal) => {
    isDialogOpen.value = newVal
  },
  { immediate: true }
)

const closeDialog = () => {
  isDialogOpen.value = false
  emit('close')
}

const saveChanges = () => {
  emit('update', { ...props.item, name: simulationName.value })
  closeDialog()
}

const onDialogUpdate = (val: boolean) => {
  if (!val) {
    closeDialog()
  }
}
</script>

<template>
  <v-dialog v-model="isDialogOpen" max-width="400" @update:model-value="onDialogUpdate">
    <v-card class="pa-3">
      <v-card-title>Update simulation</v-card-title>
      <v-card-text class="pl-4">
        <v-text-field
          v-model="simulationName"
          label="Name"
          outlined
          dense
          color="primary text-none"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary text-none" @click="closeDialog">Cancel</v-btn>
        <v-btn color="primary text-none" @click="saveChanges" :disabled="!simulationName">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
